module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Download all active layers as GPX":"Laden Sie alle aktiven Ebenen als GPX herunter","Wegue layers":"Wegue Ebenen"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/downloadlayers/DownloadLayersButton.vue
// module id = y056
// module chunks = 1